import styled from 'styled-components';
import {BGImageCenter} from '../../../../../../../globalVariables/GlobalVariables';

export const menuIconWrapper = styled.div`
    position: relative;
`;

export const menuIcon = styled.div<{icon: string}>`
    width: 16px;
    height: 16px;
    ${p => p.icon && BGImageCenter(p.icon, '12px')};
    cursor: pointer;
    opacity: 1;
    transition: opacity 0.2s;
    &:hover {
        opacity: 0.7;
    }
`;

